$(document).ready(function() {
  //
  // Sets a single error (width or height)
  //
  function setError(type) {
    $('#' + type + '-container')
      .find('label')
      .after('<span class="error">' + type + ' must be a number.</span>');
  }

  //
  // Sets all errors and returns a value
  // indicating if the form is valid.
  //
  function isValid(width, height) {
    var isValid = true;
    
    //
    // Reset errors
    //
    $('.field').find('.error').remove();
    $('#sqfoot-result').text('Error,please contact us');
    
    if (isNaN(height)) {
      setError('height');
      isValid = false;
    }
    
    if (isNaN(width)) {
      setError('width');
      isValid = false;
    }
	
    if (height<=0) {
      setError('height');
      isValid = false;
    }	
    if (width<=0) {
      setError('width');
      isValid = false;
    }
    
    return isValid;
  }

  /**
   * Handle the form submission, display success message if
   * invalid input is supplied. Otherwise display the output
   * in the target div. 
   */    
  $('#sqfoot-form').submit(function () {
    var inputs = {
      height: $('#height').val(),
      width:  $('#width').val(),
      myunit: $('#myunit').val()
    };
    
    var values = {
      height: parseFloat(inputs.height),
      width: parseFloat(inputs.width)
    };
	
	var a=values.width;
	var b=values.height;
	var myunit=inputs.myunit;

	xishu=1
switch (myunit) {
    case "ft":
        xishu=1;
        break;
    case "in":
        xishu=0.0833333;
        break;
    case "m":
        xishu=3.28084;
        break;
    case "cm":
        xishu=0.0328084;
        break;
    case "mm":
        xishu=0.00328084;

}
	
	
	var wallsize=(a*b*xishu*xishu).toFixed(2);
	
	

	if (wallsize<32) wallsize=32;
	
    var wallpaperprice=(wallsize*0.372).toFixed(0)*10-0.01;
	var vinylprice=(wallsize*0.465).toFixed(0)*10-0.01;
    var floormuralprice=(vinylprice*0.12).toFixed(0)*10-0.01
	
	var myquantity=(wallsize*0.372).toFixed(0);
	var myquantity2=(wallsize*0.465).toFixed(0);

	
 if (isValid(values.width, values.height)) {
      $('#sqfoot-result').text(
	  'Thank you for your inquiry.'+'width='+a+' '+myunit+',height='+b+' '+myunit
	  );
	  


	  $('#wallpaperprice-result').text('Wallpaper price:$'+wallpaperprice
	  	  );

	  $('#vinylprice-result').text(' Adhesive Vinyl price:$'+vinylprice+'. Floor mural price:'+floormuralprice
	  	  );	  
	  


	  $('#How-to-order-result').text('To order this size wallpaper, please choose custom size $9.99, and enter quantity '
	  +myquantity+'. So the total value is around $'+wallpaperprice+'. If you like adhesive vinyl, please choose custom size vinyl $9.99, and enter quantity '+myquantity2+'. Please leave your measurement on the checkout page. Share product page on facebook, get $5 discount. Share your finished project picture on facebook, get $5-$20 cash back. Record a short video review,get extra cash back'
	  );
	  
      
	  
	  
	  
	  
	  
    }
    return false;
  });  
});






